// extracted by mini-css-extract-plugin
export default {"body1":"Body1_body1__1CN38","body1-text-link":"Body1_body1-text-link__6oLaQ"};